import { Link } from 'react-router-dom';

interface KpiCardProps {
  label: string;
  value: string | number;
  hint?: string;
  to?: string;
  tone?: 'default' | 'success' | 'warning' | 'danger';
}

const toneClass: Record<NonNullable<KpiCardProps['tone']>, string> = {
  default: 'bg-white border-gray-200 text-gray-900',
  success: 'bg-emerald-50 border-emerald-200 text-emerald-900',
  warning: 'bg-amber-50 border-amber-200 text-amber-900',
  danger: 'bg-rose-50 border-rose-200 text-rose-900',
};

export function KpiCard({ label, value, hint, to, tone = 'default' }: KpiCardProps) {
  const inner = (
    <div className={`rounded-lg border p-4 shadow-sm h-full ${toneClass[tone]}`}>
      <div className="text-xs font-medium uppercase tracking-wide opacity-70">{label}</div>
      <div className="mt-2 text-2xl font-semibold tabular-nums">{value}</div>
      {hint ? <div className="mt-1 text-xs opacity-70">{hint}</div> : null}
    </div>
  );
  if (!to) return inner;
  return (
    <Link to={to} className="block transition hover:scale-[1.01] hover:shadow-md">{inner}</Link>
  );
}
